<template>
  <span :style="{display: isBlock ? 'block' : ''}">
    <span class="total-panel--day-number" :class="iconClass">{{
        ((percent || percent ==0) && percent !== Infinity) ? percent + "%" : '-'}}</span>
    <gj-icon :class="iconArrowClass" v-if="percent"></gj-icon>
  </span>
</template>

<script>
import _ from "lodash";
import { oppositeList } from "@/utils/setting.js";

export default {
name: "chain-ratio",
  props:{
    percent: {
      type: Number
    },
    itemKey: {
      type: String,
      default: '',
    },
    isBlock: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconClass(){
      let str = this.percent ? (this.percent >0 ? "up-icon"  : "down-icon") :""
      if(_.includes(oppositeList, this.itemKey)){
        if(this.percent<0) str ="up-icon";
        else if (!this.percent) str = "";
        else str ="down-icon";
      }
      return str;
    },
    iconArrowClass(){
      let str = this.percent ? (this.percent > 0 ? "el-icon-top"  : "el-icon-bottom") : ''
      if(_.includes(oppositeList, this.itemKey)){
        if(this.percent<0) str = "el-icon-top";
        else if (!this.percent) str = "";
        else str ="el-icon-bottom";
      }
      return str;
    }
  }
}
</script>

<style scoped>
.total-panel--day-number{
  font-size: 12px;
}
.el-icon-top,.el-icon-bottom{
  font-size: 12px;
  font-weight: bold;
}
.down-icon,.el-icon-bottom {
  color: #F56C6C;
}
.up-icon,.el-icon-top {
  color: #19BE6B;
}
</style>
